// app/frontend/controllers/score_validation_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contestForm"]

  showContestForm(event) {
    event.preventDefault()
    this.contestFormTarget.classList.remove('hidden')
  }

  hideContestForm(event) {
    event.preventDefault()
    this.contestFormTarget.classList.add('hidden')
  }
}
